import { LoadingLine } from "../../../components/loading-line.js";
import { ModalController } from "../../../components/modal/controller.js";
import { USER_OPTIONS } from "../../../config/constants.js";
import { UserPrivateController } from "../controller.js";
import { UserPrivateAuthModel } from "./model.js";
import { UserPrivateAuthView } from "./view.js";

export class UserPrivateAuthController {
  static instance = null;
  static userData = null;

  constructor() {
    if (UserPrivateAuthController.instance) {
      throw new Error("Clase singleton, use getInstance()");
    }

    this.view = new UserPrivateAuthView();
    this.model = new UserPrivateAuthModel();
    this.loading = LoadingLine.getInstance();
    this.modalLogin = null;
    this.modalRecover = null;
  }

  static getInstance() {
    if (!UserPrivateAuthController.instance) {
      UserPrivateAuthController.instance = new UserPrivateAuthController();
    }
    return UserPrivateAuthController.instance;
  }

  async sessionAlive() {
    return await new Promise((resolve, reject) => {
      if (window.localStorage.getItem('user-suuid')) {
        APICRUD.Auth.Status()
          .then(resolve)
          .catch(reject);
      } else {
        reject();
      }
    });
  }

  login() {
    let email = document.getElementById('login-email').value;
    let pass = document.getElementById('login-pass').value;
    let status = document.getElementById('login-status');
    status.innerHTML = '';
    if (email.trim() == '') {
      status.innerHTML = 'Debe ingresar un email.';
      return;
    }
    if (pass.trim() == '') {
      status.innerHTML = 'Debe ingresar su contraseña.';
      return;
    }
    this.clear();
    this.clearSession();
    APICRUD.Auth.Login('login-email', 'login-pass', 'login-status', '')
      .then(() => {
        if (window.location.pathname.indexOf('services/new') > -1) {
          window.location = '/user/services/new';
        } else {
          window.location = '/user';
        }
      })
      .catch(() => {
        this.clearSession();
      })
  }

  loginPasswordVisibility(_elem) {
    let pass = document.getElementById('login-pass') || document.getElementById('account-password');
    if (pass) {
      if (pass.getAttribute('type') == 'text') {
        pass.setAttribute('type', 'password');
        _elem.classList.add('oculto');
      } else {
        pass.setAttribute('type', 'text');
        _elem.classList.remove('oculto');
      }
    }
  }

  logout() {
    this.clearSession();
    this.clear();
    APICRUD.Auth.Logout('/');
  }

  showLogin() {
    this.modalLogin = this.view.showLogin();
    this.modalRecover?.close();
    this.modalRegister?.close();
  }

  clear() {
    let array = [APICRUD.Token];
    for (let i = 0; i < APICRUD.config.length; i++) {
      array.push(APICRUD.config[i].idcod);
    }
    for (let i = 0; i < array.length; i++) {
      Object.keys(localStorage)
        .filter(key => key.includes(array[i]))
        .forEach(key => localStorage.removeItem(key));

    }
  }

  clearSession() {
    window.localStorage.removeItem('user-data');
    window.localStorage.removeItem('user-plan');
    window.localStorage.removeItem('user-idcod');
    window.localStorage.removeItem('user-suuid');
  }

  recover() {
    document.getElementById('recover-status').setAttribute('style', 'color:white')
    document.getElementById('recover-status').innerHTML = 'Generando nueva contraseña...';
    APICRUD.Auth.Recover('recover-email')
      .then(_data => {
        if (_data.message == 'OK') {
          this.modalRecover?.close();
          let text = `Enviamos a <b>${document.getElementById('recover-email').value}</b> tu nueva contraseña.
        <br>
          <br>
        Te enviamos un correo desde <i>noreply.yumserver@gmail.com</i>. Recordá revisar tu casilla de correo <b>No deseado</b>. 
          <br>
        `;
          let modal = new ModalController('Recuperación de contraseña', text);
          modal.show();
          document.getElementById('recover-status').innerHTML = text;
        } else {
          document.getElementById('recover-status').innerHTML = 'Ocurrió un error al intentar recuperar tu cuenta.<br>' + _data.status;
        }
      })
      .catch(_data => console.log(_data))
  }

  showRecover() {
    this.modalLogin?.close();
    this.modalRegister?.close();
    this.modalRecover = this.view.showRecover();
  }

  showRegister() {
    window.location.href = '/registration';
    return;
    this.modalLogin?.close();
    this.modalRecover?.close();
    this.modalRegister = this.view.showRegister();
    APICRUD.Location.Selector_LoadStates('register-idState', 5, 0);
    APICRUD.Common.Select.SetData('register-occupation', 0, USER_OPTIONS.Cargos);
  }

  register() {
    document.getElementById('register-status').innerHTML = '';
    this.model.register()
      .then(_data => {
        let text = `Enviamos un correo a <b>${document.getElementById('register-email').value}</b> para validar tu identidad. 
        <br>
          <br>
        Te enviamos un correo desde <i>noreply.yumserver@gmail.com</i>. Recordá revisar tu casilla de correo <b>No deseado</b>. 
          <br>
          <br>
          Solo tenés que ingresar y dar click al botón <b>Validar y activar mi cuenta</b>.
        `;
        if (_data.message == 'OK') {
          if (_data.status != 'Correo enviado') {
            text = `No pudimos enviar un correo a <b>${document.getElementById('register-email').value}</b> para validar tu identidad.`;
          }
        }
        let mod = new ModalController('Nueva cuenta', `
          Se ha creado una nueva cuenta para vos.
          <br>
          ${text}
          `);
        mod.oncloseCallback = function () {
          window.location.href = '/';
        }
      })
      .catch(_data => {
        if (document.getElementById('register-status')) {
          document.getElementById('register-status').innerHTML = _data;
        }
        document.getElementById('register-btn').classList.remove('locked');
      })
  }

  activation(_code) {
    this.model.activation(_code)
      .then(() => {
        document.getElementById('content').innerHTML = `
            <h1>Activación de cuenta</h1>
            Su cuenta ha sido activada. Ya puede iniciar sesión y comenzar a publicar.
            <br>
            <button class="mt20" onclick="javascript:app.userPrivateController.auth.showLogin()">Ingresar con mi correo electrónico</button>
            `;
      })
      .catch(_error => {
        document.getElementById('content').innerHTML = `
            <h1>Activación de cuenta</h1>
        El <b>código de activación</b> puede que no pertenezca a ninguna cuenta o sea erróneo.
        <br>
            <button class="mt20" onclick="window.location.href = '/'">Seguir navegando en agrolabores.com</button>
        `;
      })
  }

  async sessionGetData() {
    return await this.model.getSessionData();
  }

  async sessionSetData(_data) {
    return await this.model.setSessionData(_data);
  }

  async getInfoUserFromIdcod(_idcod) {
    return await new Promise((resolve, reject) => {
      this.model.getInfoUserFromIdcod(_idcod)
        .then(resolve)
        .catch(reject)
    });
  }

  showAvatar(_userData) {
    this.view.showAvatar(_userData || UserPrivateController.userData);
  }

}
